<template>
 <div id="menubar">   
   <v-row>     
     <v-app-bar
      rounded
     >     
       <v-spacer></v-spacer>
      <!-- Automotriz -->
      <v-tabs
        v-if="currentUser.company_giroid==1"
        color="grey-darken-2"
        centered
      >
        <v-tab          
          v-for="link in lAutomotriz "
          :key="link"
          :text="link.text"
        >
        <router-link :to="link.to">        
          <v-icon>{{ link.icon }}</v-icon> {{ link.text }}
        </router-link>
        </v-tab>       
      </v-tabs>
      <!-- Domotica -->
      <v-tabs
        v-else-if="currentUser.company_giroid==192"
        color="grey-darken-2"
        centered
      >
        <v-tab          
          v-for="link in lAll"
          :key="link"
          :text="link.text"
        >
        <router-link :to="link.to">        
          <v-icon>{{ link.icon }}</v-icon> {{ link.text }}
        </router-link>
        </v-tab>       
      </v-tabs>
      <!-- Otros -->
      <v-tabs
        v-else
        color="grey-darken-2"
        centered
      >
      <!-- {{ currentUser.cml_name }} -->
      <!-- {{ currentUser.company_giroid }} -->
        <v-tab          
          v-for="link in lAll"
          :key="link"
          :text="link.text"
        >
        <router-link :to="link.to">        
          <v-icon>{{ link.icon }}</v-icon> {{ link.text }}
        </router-link>
        </v-tab>
        <!-- <v-tab> -->
           <!-- Eventos -->
            <!-- <Notify />  -->
            <!-- FIN Eventos -->
        <!-- </v-tab> -->
      </v-tabs>
    </v-app-bar>
   </v-row> 
 </div>
</template>

<script>
import {mapState} from "vuex";
// import{ mapMutations } from "vuex" ;
// import{ mapMutations,mapState } from "vuex";
//import SearchProducts from "./components/SearchProducts.vue";
// import ToolTop from "@/components/ToolTop";
// import Breadcrumbs from '@/components/Breadcrumbs';
// import Footer from "@/components/Footer";
// import icheckApi from '@/services/icheckApi';
// import FieldSearch from '@/components/FieldSearch.vue'
// import CarItemPOS from "@/components/CarItemPOS";
// import Notify from '@/components/Notify'


export default{
    name:'menubar',
    computed:{
        ...mapState(['currentUser'])
    },
    components:{         
    },
    methods:{
    
    },
    data: () => ({     
      enabled: false,      
      dragging: false,
      dialog: false,
      toggle_exclusive:'',
      draggingInfo:'',
      sword:"",
      productrow:{},
      priceid:'',
      refresh:false,
      sfecha:new Date().toISOString().substr(0,10),
      rows: [],
      subtotal:0,
      car_subtotal:0,
      editRow:null,
      lAll: [
        { text: 'Articulos', to:'/articulos', icon:'dns' },
        { text: 'Precios', to:'/preciosenlista', icon:'price_change' },
        { text: 'Cotizacion', to:'/quotes', icon:'receipt_long' },
        { text: 'Salidas', to:'/ventas', icon:'add_shopping_cart' },
        { text: 'Gastos', to:'/gastos', icon:'attach_money' },
        { text: 'Compras', to:'/compras', icon:'add_shopping_cart' },
        { text: 'Devoluciones', to:'/devoluciones', icon:'undo' },
        { text: 'Clientes', to:'/clientes', icon:'group_add' },
        { text: 'Plugins', to:'/plugins', icon:'extension' },                
      ],
      lAutomotriz: [
        { text: 'Marcas', to:'/catalogomarcas', icon:'dns' },
        { text: 'Modelos', to:'/catalogomodelos', icon:'price_change' },
        { text: 'Versiones', to:'/catalogoversion', icon:'receipt_long' },
        { text: 'Autos', to:'/autos', icon:'add_shopping_cart' },                       
      ],
      theader: [
        { text: 'Acción', value: 'canasta_basica' },
        { text: '#', value: 'subtotal_quote' },
        // {
        //   text: 'ID',
        //   align: 'start',
        //   sortable: false,
        //   value: 'id',
        // },
        
        { text: 'Imagen', value: 'filename' },        
        { text: 'Producto', value: 'subtotal_quote' },
        { text: 'Precio de Lista', value: 'precio_other' },
        { text: 'Descuento', value: 'discount' },                
        { text: 'Precio Unidad', value: 'precio_other' },
        { text: 'Cantidad', value: 'cantidad' },                
        { text: 'Importe', value: 'total_quote' }, 
        { text: 'Fecha Registro', value: 'created_at' },
        { text: 'Fecha Actualización', value: 'updated_at' },
      ],
      acciones: [
        { title: 'Download PDF',icon:"save",metodo:"downloadPDF" }
      ],
    }),
    created(){
      // this.getCar()     
    }
}
</script>
